import { render, staticRenderFns } from "./RolloverSalaryAdvance.vue?vue&type=template&id=0e6ec8a0&"
import script from "./RolloverSalaryAdvance.vue?vue&type=script&lang=js&"
export * from "./RolloverSalaryAdvance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports